<!--suppress TypeScriptUnresolvedVariable -->
<div class="planning-container">
    <div fxLayout="column" fxLayoutGap="24px" class="ec-planning-main-panel">
        <div fxLayout fxFlex>
            <ng-container *ngIf="network|async as network">
                <button app-small-ghost-button class="app-base-button"
                        (click)="onClickGotoResources(network.root)">
                    <app-icon name="fal-arrow-left"></app-icon>
                    {{'Back to resources'|i18n}}
                </button>
            </ng-container>
        </div>
        <div fxLayout="row" fxLayoutGap="24px" fxFlex>
            <div class="resource-tree">
                <app-ec-resource-tree [network]="treeNetwork"
                                      (selectionChange)="onSelectResource($event)">
                </app-ec-resource-tree>
            </div>
            <div fxLayout="column" class="ec-planning-charts-panel">
                <ng-container *ngIf="planning|async as planning; else loadingPlanning">
                    <ng-container *ngIf="network|async as network">
                        <ng-container *ngIf="planningResult|async as planningResult">
                            <div fxLayout="column" fxLayoutGap="30px" class="bg-1">
                                <div fxLayout="column" fxLayoutAlign="space-between" class="bg-2" fxLayoutGap="20px">
                                    <div fxLayout="row">
                                        <span class="txt-h-18-7">{{network.root.path|nicePath}}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="20px">
                                        <div fxLayout="column" fxLayoutGap="20px" class="bg-3" fxFlex="50">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                                <span class="txt-h-16-7">{{('Source'|i18n) + ':'}}</span>
                                                <span class="txt-ec-16-4">{{(planning|planningSource) || 'Unknown'|i18n}}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                                <span class="txt-h-16-7">{{('Planner'|i18n) + ':'}}</span>
                                                <span class="txt-ec-16-4">{{(plannerName(planning)|i18n) || 'Unknown'|i18n}}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                                <span class="txt-h-16-7"><app-icon
                                                        name="fal-calendar-alt"></app-icon>&nbsp;{{('Created'|i18n) + ':'}}</span>
                                                <span class="txt-ec-16-4">{{planning.planning_timestamp|i18nTimestamp}}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                                <div class="txt-h-16-7"><app-icon name="fal-stopwatch"></app-icon>&nbsp;{{('Time range'|i18n) + ':'}}</div>
                                                <div class="bg-4"><span
                                                        class="txt-ec-16-4">{{planning.start_time|i18nTimestamp}}</span>
                                                </div>
                                                <div class="bg-4"><span
                                                        class="txt-ec-16-4">{{planning.end_time|i18nTimestamp}}</span>
                                                </div>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                                <span class="txt-h-16-7">{{('Strategy'|i18n) + ':'}}</span>
                                                <span class="txt-ec-16-4">{{(planning|planningStrategy) || ('Unknown'|i18n)}}</span>
                                            </div>
                                        </div>
                                        <div fxLayout="column" fxLayoutGap="20px" class="bg-3 aggregations-row"
                                             fxFlex="50">
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                                <span class="txt-h-16-7">{{('Report'|i18n)}}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
                                                 class="aggregation">
                                                <span class="txt-h-18-7">{{planningResult.sharedPower|niceValue:'KWh':2}}</span>
                                                <span class="txt-h-14-4">{{'Shared energy'|i18n}}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
                                                 class="aggregation">
                                                <span class="txt-h-18-7">{{planningResult.sharingRatio + '%'}}</span>
                                                <span class="txt-h-14-4">{{'Sharing energy ratio'|i18n}}</span>
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
                                                <div class="txt-h-16-7">{{('Outcome'|i18n) + ':'}}</div>
                                                <div class="bg-4"> <span class="txt-ec-16-4"><app-icon
                                                        [name]="planning.status|planningStatusIcon"></app-icon>&nbsp;
                                                    {{planning.status|planningStatus}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <div fxLayout="row" *ngIf="treeNetwork">
                    <ng-container *ngIf="planning|async as planning; else loadingPlanning">
                        <div class="mt-24 ec-planning-charts-panel"> <!-- TODO  style="width: 100%" why? -->
                            <app-community-planning-data [planning]="planning" [network]="treeNetwork.network"
                                                             [resourceId]="resourceId">
                            </app-community-planning-data>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loadingPlanning>
    <div fxLayout="column">
        <div fxLayout="row inline" fxFlexAlign="center" class="mt-24 mb-16">
            <mat-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{'Loading planning'|i18n}}...</span>
        </div>
    </div>
</ng-template>
